import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import NavBar from './Components/NavBar/NavBar';
import Loading from './Components/Loading';
import ScrollToTop from './ScrollToTop';
import ScrollToTopButton from './Components/ScrollToTop';
import GlobalHeader from './Components/GlobalHeader';
import GlobalFooter from './Components/GlobalFooter';
import './App.css';

const Home = lazy(() => import('./Pages/Home/Home'));
const Anime = lazy(() => import('./Pages/AnimeList'));
const AnimeDetail = lazy(() => import('./Pages/AnimeDetail'));
const NoMatch = lazy(() => import('./Components/NoMatch'));

const App = () => {
	return (
		<>
		<GlobalHeader />
			<NavBar />
			<ScrollToTop />
			<Suspense fallback={<div className='container'><div className='lazyload'>
				<Loading />
				</div></div>}>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/:season/:section" element={<Anime/>} />
					<Route path="/:season/:section/:slug" element={<AnimeDetail />}/>
					<Route path="*" element={<NoMatch />} />
				</Routes>
			</Suspense>
			      
			<ScrollToTopButton />
		<GlobalFooter />
		</>
	);
};

export default App;
